"use strict";
'use client';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.ServiceWorkerContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _utils = require("../../utils");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
const {
  serviceWorker
} = _utils.browser || {};
const defaultContext = {
  statuses: {}
};
const ServiceWorkerContext = exports.ServiceWorkerContext = /*#__PURE__*/(0, _react.createContext)(defaultContext);
function ServiceWorkerWrapper(_ref) {
  let {
    children,
    workers
  } = _ref;
  const [statuses, setStatuses] = (0, _react.useState)(() => Object.fromEntries(workers.map(sw => [sw, 'pending'])));
  (0, _react.useEffect)(() => {
    workers.forEach(swPath => {
      serviceWorker.register(swPath).then(status => {
        setStatuses(prev => _objectSpread(_objectSpread({}, prev), {}, {
          [swPath]: status
        }));
      });
    });
  }, [workers]);
  return /*#__PURE__*/_react.default.createElement(ServiceWorkerContext.Provider, {
    value: {
      statuses
    }
  }, children);
}
ServiceWorkerWrapper.useServiceWorker = () => (0, _react.useContext)(ServiceWorkerContext);
var _default = exports.default = ServiceWorkerWrapper;